import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

export default function Account({ color }) {
  const theme = useContext(ThemeContext);
  return (
    <svg width='18' height='17' viewBox='0 0 18 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.0026 9.22483C11.4572 9.22483 13.447 7.23498 13.447 4.78038C13.447 2.32578 11.4572 0.335938 9.0026 0.335938C6.54801 0.335938 4.55816 2.32578 4.55816 4.78038C4.55816 7.23498 6.54801 9.22483 9.0026 9.22483ZM0.117188 17.0052C0.117188 13.3233 4.09688 10.3385 9.00608 10.3385C13.9153 10.3385 17.895 13.3233 17.895 17.0052H0.117188Z'
        fill={color ? theme.palette[color] : theme.dim['60_white']}
      />
    </svg>
  );
}
